const DB_NAME = 'titan-vault';
let dbp = null;

function open() {
  if (!dbp) {
    dbp = new Promise((resolve, reject) => {
      const r = indexedDB.open(DB_NAME, 1);
      r.onupgradeneeded = () => {
        const db = r.result;
        if (!db.objectStoreNames.contains('games')) db.createObjectStore('games', { keyPath: 'id' });
        if (!db.objectStoreNames.contains('kv')) db.createObjectStore('kv');
      };
      r.onsuccess = () => resolve(r.result);
      r.onerror = () => reject(r.error);
    });
  }
  return dbp;
}

async function tx(store, mode, fn) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(store, mode);
    const req = fn(t.objectStore(store));
    t.oncomplete = () => resolve(req?.result);
    t.onerror = () => reject(t.error);
  });
}

export const db = {
  allGames: () => tx('games', 'readonly', (s) => s.getAll()),
  getGame: (id) => tx('games', 'readonly', (s) => s.get(id)),
  putGame: (g) => tx('games', 'readwrite', (s) => s.put(g)),
  delGame: (id) => tx('games', 'readwrite', (s) => s.delete(id)),
  kvGet: (k) => tx('kv', 'readonly', (s) => s.get(k)),
  kvSet: (k, v) => tx('kv', 'readwrite', (s) => s.put(v, k)),
};

export const uid = () => (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36));
